
export default function ContattiCTA() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#0B1F3B] to-blue-900">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Il Primo Passo Verso la Valorizzazione
        </h2>
        <p className="text-xl text-blue-100 mb-8 leading-relaxed">
          Non rimandare. Ogni giorno che passa senza valorizzare il tuo brand è un'opportunità persa. 
          La pre-analisi gratuita è il primo passo verso il successo.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-8">
          <a 
            href="mailto:info@brandcapital.it" 
            className="bg-green-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-green-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Richiedi Pre-Analisi Ora
          </a>
          <a 
            href="tel:+390212345678" 
            className="border-2 border-[#E879F9] text-[#E879F9] px-8 py-4 rounded-lg font-semibold hover:bg-[#E879F9] hover:text-white transition-all whitespace-nowrap cursor-pointer"
          >
            Chiamaci Direttamente
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-6 text-center">
          <div className="bg-white/5 backdrop-blur-sm rounded-lg p-6">
            <i className="ri-gift-line text-3xl text-[#E879F9] mb-3 block"></i>
            <h3 className="text-lg font-semibold text-white mb-2">100% Gratuito</h3>
            <p className="text-blue-200 text-sm">Nessun costo nascosto</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm rounded-lg p-6">
            <i className="ri-time-line text-3xl text-green-400 mb-3 block"></i>
            <h3 className="text-lg font-semibold text-white mb-2">Risposta Rapida</h3>
            <p className="text-blue-200 text-sm">Entro 2 ore lavorative</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm rounded-lg p-6">
            <i className="ri-award-line text-3xl text-[#E879F9] mb-3 block"></i>
            <h3 className="text-lg font-semibold text-white mb-2">Professionalità</h3>
            <p className="text-blue-200 text-sm">Consulenti certificati</p>
          </div>
        </div>
      </div>
    </section>
  );
}
